<template>
    <div class="scroll">
        <el-dialog :visible.sync="showDigitalVoucher" :center="true" @close="closeRedemptionDetailModal">
            <div class=" justify-content-center flex-column text-center text-bat popups-redemptions scroll-vert"
                style="word-break: normal">
                <div class="">
                    <div>
                        <div class="d-flex justify-content-between header">
                            <div class="header text-start">
                                <div>
                                    <div v-if="redemption_details.StatusName === 'Aprobado'">
                                        <span class="badge tag-entregado">Estado</span>
                                        <span class="traffic-light tag-entregado"></span>
                                        {{ redemption_details.StatusName }}

                                    </div>
                                    <div v-else-if="redemption_details.StatusName === 'En proceso de aprobación'">
                                        <span class="badge tag-despachado">Estado</span>
                                        <span class="traffic-light tag-despachado"></span>
                                        {{ redemption_details.StatusName }}

                                    </div>
                                    <div v-else>
                                        <span class="badge tag-entregado">Estado</span>
                                        <span class="traffic-light tag-entregado"></span>
                                        {{ redemption_details.StatusName }}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h6 class="mb-3 mt-4 text-start text-title-bat"> {{ redemption_details.ProductName }}</h6>
                    </div>
                    <!-- Condiciones para mostrar descripcion del producto -->
                    <div>
                        <h6 v-if="redemption_details.ProductTypeId === 1 && redemption_details.LinkPdfRedemption && redemption_details.LinkPdfRedemption !== ''"
                            class="mb-3 text-start text-bat">Acabas de redimir en {{ segmentation_id === 5 ? 'Conecta2 contigo' : 'Conecta2' }} tu bono de {{ redemption_details.ProductName }}.
                        </h6>
                        <h6 v-else-if="redemption_details.ProductTypeId === 2 || redemption_details.ProductTypeId === 3"
                            class="mb-3 text-start text-bat">Acabas de redimir tu {{ redemption_details.ProductName }}
                            en {{ segmentation_id === 5 ? 'Conecta2 contigo' : 'Conecta2' }}.</h6>
                        <h6 v-else-if="redemption_details.ProductTypeId === 5" class="mb-3 text-start text-bat">Acabas
                            de redimir tu {{ redemption_details.ProductName }}.</h6>
                        <h6 v-else-if="redemption_details.ProductTypeId === 6" class="mb-3 text-start text-bat">Acabas
                            de redimir en {{ segmentation_id === 5 ? 'Conecta2 contigo' : 'Conecta2' }} tu bono de {{
            redemption_details.ProductName }}.</h6>
                        <h6 v-else-if="redemption_details.ProductTypeId === 7 || redemption_details.ProductTypeId === 11 || redemption_details.ProductTypeId === 12 || redemption_details.ProductTypeId === 13"
                            class="mb-3 text-start text-bat">Acabas
                            de redimir en {{ segmentation_id === 5 ? 'Conecta2 contigo' : 'Conecta2' }} {{
            redemption_details.QUANTITY }} {{ redemption_details.ProductName
                            }}.</h6>
                        <h6 v-else-if="redemption_details.ProductTypeId === 8" class="mb-3 text-start text-bat">Acabas
                            de redimir en {{ segmentation_id === 5 ? 'Conecta2 contigo' : 'Conecta2' }} tu bono de {{
            redemption_details.ProductName }} con el documento de
                            identidad {{ user_data.identification_number }}.</h6>
                        <h6 v-else-if="redemption_details.ProductTypeId === 9" class="mb-3 text-start text-bat">Acabas
                            de redimir en {{ segmentation_id === 5 ? 'Conecta2 contigo' : 'Conecta2' }} tu bono de {{
            redemption_details.ProductName }} con el documento de
                            identidad {{ user_data.identification_number }}.</h6>
                        <h6 v-else-if="redemption_details.ProductTypeId === 10" class="mb-3 text-start text-bat">
                            Redimiste 1 bono digital de {{ redemption_details.ProductName }} en {{ segmentation_id === 5
            ? 'Conecta2 contigo' : 'Conecta2' }}.</h6>
                        <h6 v-else class="mb-3 text-start text-bat">Redimiste 1 bono digital de {{
            redemption_details.ProductName }} en {{ segmentation_id === 5 ? 'Conecta2 contigo' :
            'Conecta2' }}.</h6>
                    </div>
                    <div>
                        <img v-if="redemption_details.ProductImage"
                            :src="my_redemptions.domain + redemption_details.ProductImage.replace('~/', '')"
                            :alt="redemption_details.ProductName" width="50%" class="mb-4">
                        <img v-else :src="my_redemptions.domain + redemption_details.ProductImage"
                            :alt="redemption_details.ProductName">
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col text-bat">
                                <h6 class="mb-3 text-start text-title-bat">Puntos</h6>
                            </div>
                            <div class="col box-points-redemptions d-flex flex-column flex-wrap align-content-end">
                                <span class="points-redemptions d-inline-flex text-title px-2"
                                    v-if="redemption_details.ProductTypeId === 2">
                                    <strong>
                                        {{ redemption_details.PointsUnitShippingValue +
            redemption_details.PointsUnitValue }} <span>Puntos</span>
                                    </strong>
                                </span>
                                <span v-else class="points-redemptions d-inline-flex text-title px-2"><strong>
                                        {{ redemption_details.PointsUnitValue }} <span> Puntos</span></strong></span>
                            </div>
                        </div>
                        <!-- Condiciones para mostrar contenido -->
                        <div>
                            <div
                                v-if="redemption_details.ProductTypeId === 1 && redemption_details.LinkPdfRedemption && redemption_details.LinkPdfRedemption !== ''">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">Descarga el archivo donde encontrarás el código
                                    de
                                    tu bono.</h6>
                                <div class="pb-3">
                                    <button class="w-100 mx-1 btn btnBlue text-title-bat rounded-3 text-uppercase "
                                        @click="downloadBonus()"> Descargar Bono <img
                                            src="/img/icons/document-download.png" alt="Icono de descarga"
                                            class="ms-2"></button>
                                </div>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 2">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">
                                    Tu producto será entregado en los siguientes 15 días hábiles de tu fecha de
                                    redención.
                                </h6>
                                <div class="col text-start mb-2 text-redemption">
                                    <h6>Cantidad</h6>
                                    <span> {{ redemption_details.QUANTITY }}</span>
                                </div>
                                <div>
                                    <div class="col text-start mb-2 text-redemption">
                                        <h6>Fecha de redención</h6>
                                        <span>{{ formatDate(redemption_details.OrderDate) }}</span>
                                    </div>
                                    <div class="col text-start mb-4">
                                        <h6>Lugar de entrega que indicaste</h6>
                                        <span> {{ redemption_details.Address }}</span>
                                        <span> {{ redemption_details.NameCity }}</span>
                                        <span> {{ redemption_details.NameDepartments }}</span>
                                        <br>
                                        <span> {{ redemption_details.ShippingAditionalInfo }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 3">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">Tu recarga será entregada en los siguientes 2
                                    días hábiles de tu fecha de redención.</h6>
                                <h6 class="mb-3 text-start text-title-bat">Número de celular</h6>
                                <h6 class="mb-3 text-start text-bat"> {{ redemption_details.RechargeMobilePhone }}
                                </h6>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 5">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">Tú bono estará activo para que lo uses en 3
                                    días hábiles a partir de la redención. </h6>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 6">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">En los siguientes 4 días hábiles recibirás un
                                    correo electrónico con el bono en PDF. </h6>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 7">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">Descarga el archivo donde encontrarás el código
                                    de tu bono.</h6>
                                <div class="d-flex flex-column align-items-center pb-3">
                                    <button class="w-100 mx-1 btn btnBlue text-title-bat rounded-3 text-uppercase"
                                        @click="downloadBonus()"> Descargar Bono<img
                                            src="/img/icons/document-download.png" alt="Icono de descarga"
                                            class="ms-2"></button>
                                    <button
                                        class="mt-3 w-100 mx-1 btn text-title-bat rounded-3 text-uppercase btn-bonus"
                                        @click="bonusUse()">Conoce dónde usar tu Bono</button>
                                </div>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 8">
                                <div>
                                    <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                    <h6 class="mb-3 text-start text-bat">Indícale al cajero el número del
                                        convenio<strong> 1618.</strong></h6>
                                </div>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 9">
                                <div>
                                    <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                    <h6 class="mb-3 text-start text-bat">En los siguientes 3 días hábiles tu bono
                                        estará activo para que puedas usarlo.</h6>
                                </div>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 10">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">
                                    <span class="code" :v-model="CodigoDigital" ref="CodigoDigital">{{
            redemption_details.CodigoDigital }} </span>
                                    <img src="/img/icons/icon-copy.svg" alt="" class="ps-3" @click="copyText()">
                                </h6>
                                <div class="d-flex flex-column align-items-center pb-3">
                                    <a class="w-100 mx-1 btn btnBlue text-title-bat rounded-3 text-uppercase" href="/pedidos">Usar Bono</a>
                                </div>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 11">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                    <h6 class="mb-3 text-start text-bat">
                                        Recibirás la confirmación exitosa por correo de que el monto fue recargado en tu tarjeta de cuatro a cinco días hábiles después de tu fecha de redención.</h6>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 12">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">
                                    Tu producto será entregado en los siguientes 15 días hábiles de tu fecha de redención.
                                </h6>
                                <div>
                                    <div class="col text-start mb-2 text-redemption">
                                        <h6>Fecha de redención</h6>
                                        <span>{{ formatDate(redemption_details.OrderDate) }}</span>
                                    </div>
                                    <div class="col text-start mb-4">
                                        <h6>Lugar de entrega que indicaste</h6>
                                        <span> {{ redemption_details.Address }}</span>
                                        <span> {{ redemption_details.NameCity }}</span>
                                        <span> {{ redemption_details.NameDepartments }}</span>
                                        <br>
                                        <span> {{ redemption_details.ShippingAditionalInfo }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="redemption_details.ProductTypeId === 13">
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">
                                    Tu producto será entregado en los siguientes 15 días hábiles de tu fecha de redención.
                                    <br>
                                    A partir de ahora el saldo disponible se traslada automáticamente a la nueva tarjeta que recibirás. Si aún no has bloqueado la anterior tarjeta, comunícate con Victoria y haz la solicitud.
                                </h6>
                                <div>
                                    <div class="col text-start mb-2 text-redemption">
                                        <h6>Fecha de redención</h6>
                                        <span>{{ formatDate(redemption_details.OrderDate) }}</span>
                                    </div>
                                    <div class="col text-start mb-4">
                                        <h6>Lugar de entrega que indicaste</h6>
                                        <span> {{ redemption_details.Address }}</span>
                                        <span> {{ redemption_details.NameCity }}</span>
                                        <span> {{ redemption_details.NameDepartments }}</span>
                                        <br>
                                        <span> {{ redemption_details.ShippingAditionalInfo }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <h6 class="mb-3 text-start text-title-bat">Disfruta de tu redención:</h6>
                                <h6 class="mb-3 text-start text-bat">
                                    <span class="code">{{ redemption_details.CodigoDigital }}</span>
                                </h6>
                            </div>
                            <div v-if="redemption_details.ProductTypeId !== 2 && redemption_details.ProductTypeId !== 12 && redemption_details.ProductTypeId !== 13" >
                                <div>
                                    <div class="row mb-3 mt-3 text-redemption">
                                        <div class="col text-start ">
                                            <h6>Fecha de redención</h6>
                                            <span> {{ formatDate(redemption_details.OrderDate) }}</span>
                                        </div>
                                        <div class="col  text-start">
                                            <h6>Úsalo antes de</h6>
                                            <span>{{ formatDate(redemption_details.DigitalProductExpirationDate)
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="accordion accordion-flush" id="accordionFlushExample"
                        v-if="redemption_details.ProductTypeId === 1 || redemption_details.ProductTypeId === 4 || redemption_details.ProductTypeId === 5 || redemption_details.ProductTypeId === 6 || redemption_details.ProductTypeId === 7 || redemption_details.ProductTypeId === 8 || redemption_details.ProductTypeId === 9 || redemption_details.ProductTypeId === 10 || redemption_details.ProductTypeId === 11 || redemption_details.ProductTypeId === 12 || redemption_details.ProductTypeId === 13">
                        <div class="accordion-item text-start">
                            <h2 class="accordion-header" id="flush-headingOne">
                                <button class="accordion-button collapsed text-terms" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                                    aria-controls="flush-collapseOne">
                                    Sigue estos pasos para usarlo:
                                </button>
                            </h2>
                            <div id="flush-collapseOne" class="accordion-collapse collapse text-terms"
                                aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                <p v-html="this.instructions" class="mb-0"></p>
                            </div>
                        </div>
                        <div class="accordion-item text-start">
                            <h2 class="accordion-header" id="flush-headingTwo">
                                <button class="accordion-button collapsed text-term" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                    aria-controls="flush-collapseTwo">
                                    Ten en cuenta los términos y condiciones
                                </button>
                            </h2>
                            <div id="flush-collapseTwo" class="accordion-collapse collapse text-term"
                                aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                <p v-html="this.terms" class="mb-0"></p>
                            </div>
                        </div>
                    </div>



                    <div class="accordion accordion-flush" id="accordionFlushExample" v-else>
                        <div class="accordion-item text-start">
                            <h2 class="accordion-header" id="flush-headingTwo">
                                <button class="accordion-button collapsed text-term" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                    aria-controls="flush-collapseTwo">
                                    Ten en cuenta los términos y condiciones
                                </button>
                            </h2>
                            <div id="flush-collapseTwo" class="accordion-collapse collapse text-term"
                                aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                <p v-html="this.terms" class="mb-0 px-3"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    components: {

    },
    props: {
        url_media: {
            default: '',
        },
        redemption_details: Object,
        history_points: Object,
        my_redemptions: Object,
        closeRedemptionDetailModal: Function,
        user_data: Object,
        segmentation_id: {
            type: Number,
            default: 0,
        },

    },
    data() {
        return {
            showDigitalVoucher: true,
            terms: '',
            instructions: '',
            linkPdf: '',
            linkBonusBAT: '',
            CodigoDigital: ''
        }
    },
    mounted() {
        var victoriatour = document.getElementById('victoriatour');
        if (victoriatour) {
            victoriatour.style.display = 'none';
        } else {
            console.error('Elemento victoriatour no encontrado en el DOM');
        }
    },
    created() {
        if (this.redemption_details) {
            this.terms = this.redemption_details.Terms;
            this.instructions = this.redemption_details.Instructions
            this.linkPdf = this.redemption_details.LinkPdfRedemption
            this.linkBonusBAT = this.redemption_details.LinkPdfRedemption
            this.CodigoDigital = this.redemption_details.CodigoDigital

        }
    },
    methods: {

        downloadBonus() {
            if (window && this.linkPdf) {
                window.open(this.linkPdf, '_blank');
            } else {
                console.error('Cannot download bonus: window or linkPdf is undefined.');
            }
        },
        bonusUse() {
            window.location.href = "https://netcommerce.conectadosweb.com.co/Files/FileCorbeta/COMERCIOS_BONO_DIGITAL_PREMIUM.xlsx";
        },
        bonusBAT() {
            const bonusUrl = "https://www.conectadosweb.com.co/";
            if (bonusUrl) {
                window.open(bonusUrl, '_blank');
            } else {
                console.error('Cannot open bonus: bonusUrl is not defined.');
            }
        },
        copyText() {
            const element = this.$refs.CodigoDigital;
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand('copy');
            selection.removeAllRanges();
        },
        formatDate(date) {
            if (!date) {
                return '';
            }

            if (typeof date === 'string' && date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                const parts = date.split('/');
                const day = parseInt(parts[0], 10);
                const month = parseInt(parts[1], 10) - 1;
                const year = parseInt(parts[2], 10);

                date = new Date(year, month, day);
            } else {
                date = new Date(date);
            }

            if (isNaN(date.getTime())) {
                return 'Fecha inválida';
            }

            const day = date.getDate();
            const month = date.getMonth() + 1; 
            const year = date.getFullYear();

            return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
        },
    },
}
</script>
